module.exports = __webpack_public_path__ + "img/no_data_news.6eebd9f1.png";